import Vue from 'vue';
import _ from 'lodash';
import { HTTP, SEARCH } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const defaultCollection = {
  _embedded: {
    artwork: {},
  },
};

export default {
  actions: {
    async [actions.DO_ADD_EPISODE_TO_COLLECTION]({ commit }, payload) {
      const { id } = payload;
      const episodeId = payload.episode_id;
      const params = Object.assign({}, payload);
      delete params.id;
      delete params.episode_id;
      const { data } = await HTTP.post(`/episode_collections/${id}/episodes/${episodeId}`, params);
      return data;
    },
    async [actions.DO_CREATE_COLLECTION]({ commit }, params) {
      const { data } = await HTTP.post('/episode_collections', params);
      commit(mutations.SET_COLLECTION, data.data.episode_collections[0]);
      return data;
    },
    async [actions.DO_DELETE_COLLECTION]({ commit }, payload) {
      const { id, ignore, ...params } = payload;
      const { data } = await HTTP.delete(`/episode_collections/${id}`, params);
      if (!ignore) commit(mutations.SET_COLLECTION, data.data.episode_collections[0]);
      return data;
    },
    async [actions.DO_DELETE_EPISODE_FROM_COLLECTION]({ commit }, payload) {
      const { id } = payload;
      const episodeId = payload.episode_id;
      const params = Object.assign({}, payload);
      delete params.id;
      delete params.episode_id;
      const { data } = await HTTP.delete(`/episode_collections/${id}/episodes/${episodeId}`, params);
      return data;
    },
    async [actions.DO_GET_COLLECTION]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/episode_collections/${id}`, { params });
      commit(mutations.SET_COLLECTION, data.data.episode_collections[0]);
      return data;
    },
    async [actions.DO_GET_COLLECTIONS]({ commit }, params) {
      const { data } = await HTTP.get('/episode_collections', { params });
      commit(mutations.SET_COLLECTION, data.data.episode_collections);
      return data;
    },
    async [actions.DO_GET_EPISODES_FOR_COLLECTION]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/episode_collections/${id}/episodes`, { params });
      commit(mutations.SET_COLLECTION_FIELD, {
        key: '_embedded.episodes',
        val: data.data.episodes,
      });
      return data;
    },
    async [actions.DO_SEARCH_COLLECTIONS]({ commit }, payload) {
      const { data } = await SEARCH.post('/doxa_episode_collections/episode_collection/_search', payload);
      const channels = data.hits.hits.map(h => h._source);
      commit(mutations.SET_COLLECTIONS, channels);
      return data;
    },
    async [actions.DO_UPDATE_COLLECTION]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.patch(`/episode_collections/${id}`, params);
      commit(mutations.SET_COLLECTION, data.data.episode_collections[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_COLLECTION]: state => state.collection,
    [getters.GET_COLLECTION_FILTERS]: state => state.filters,
    [getters.GET_COLLECTIONS]: state => state.collections,
  },
  mutations: {
    [mutations.SET_COLLECTION](state, collection) {
      state.collection = collection;
    },
    [mutations.SET_COLLECTION_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.collection;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_COLLECTION_FILTER_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.filters;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_COLLECTIONS](state, collections) {
      state.collections = collections;
    },
    [mutations.UNSET_COLLECTION](state) {
      state.collection = _.cloneDeep(defaultCollection);
    },
  },
  state: {
    collection: _.cloneDeep(defaultCollection),
    collections: [],
    filters: {
      sort: {
        field: 'year',
        order: 'desc',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/collection.js